// extracted by mini-css-extract-plugin
export var container = "Tabs_container__aVXCq";